import { KrContributor } from "@/types";
import { UserAvatar } from "@/components/UserAvatar";
import { cn } from "@/lib/utils";

const MAX_SHOWN = 5;

interface ContributorStackProps {
    contributors: KrContributor[];
    /** Total contributors on the BE; `contributors` is capped, so the overflow count comes from here. */
    count: number;
    className?: string;
    /** Singular noun for the tooltip */
    noun?: string;
}

/** Avatars of the people with an open deliverable under a KR. */
export function ContributorStack({ contributors, count, className, noun = "contributor" }: ContributorStackProps) {
    if (count === 0) return null;
    const shown = contributors.slice(0, MAX_SHOWN);
    const overflow = count - shown.length;

    return (
        <div
            className={cn("flex items-center -space-x-1 shrink-0", className)}
            title={`${count} ${noun}${count === 1 ? "" : "s"}: ${contributors.map(c => c.fullName).join(", ")}`}
        >
            {shown.map(c => (
                <UserAvatar key={c.pid} src={c.avatarUrl ?? undefined} name={c.fullName}
                    className="h-[18px] w-[18px] ring-1 ring-background" fallbackClassName="text-[8px]" />
            ))}
            {overflow > 0 && (
                <span className="flex h-[18px] items-center rounded-full bg-muted px-1 text-[9px] font-medium text-muted-foreground ring-1 ring-background">
                    +{overflow}
                </span>
            )}
        </div>
    );
}
